import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { RemPerUnitSize } from '@dealstack/frontend/shared/components/Table/DefaultTable/DefaultTable';
import { TagPair } from '@dealstack/frontend/shared/components/TagPair/TagPair';
import { Tooltip } from '@dealstack/frontend/shared/components/Tooltip/Tooltip';
import { useSecurityTypeTranslation } from '@dealstack/frontend/shared/translationControllers/useCommonTranslationsController';
import styled from 'styled-components';
import { LoanDefinitionType, SecurityType } from '@dealstack/shared/lib/generated';

export const TableSecurityTagPair = styled(
	({
		name,
		type,
		className,
	}: {
		name: string;
		type: SecurityType | LoanDefinitionType;
		className?: string;
		align?: 'center' | 'right';
		size?: number;
	}) => {
		const getSecurityTypeTranslation = useSecurityTypeTranslation();

		return (
			<TagPair
				titleProps={{ uppercase: false }}
				title={getSecurityTypeTranslation(type)}
				className={className}
			>
				<Tooltip hoverChildrenInsteadIcon tooltip={name}>
					<Text elipsis noWrap variant="p-sm" bold>
						{name}
					</Text>
				</Tooltip>
			</TagPair>
		);
	}
)`
	gap: 0;

	${Text} {
		/* Remove 1em for right margin. */
		${({ size }) => (size ? `width:calc(${size * RemPerUnitSize}rem - 1em);` : null)}
	}
	${({ align }) => {
		if (!align) {
			return null;
		}
		return align === 'center' ? 'align-items:center' : 'align-items:flex-end';
	}};
`;
